import { createApi } from "@reduxjs/toolkit/query/react";

import type {
  IAddBlackoutPeriodRequest,
  IUpdateBlackoutPeriodRequest,
  TAddBlackoutPeriodResponse,
  TGetBlackoutPeriodByIdRequest,
  TGetBlackoutPeriodByIdResponse,
  TGetBlackoutPeriodsListingRequest,
  TGetBlackoutPeriodsListingResponse,
  TUpdateBlackoutPeriodResponse,
} from "@/types/(company)/blackoutPeriod.interface";
import { dynamicBaseQuery } from "@/api/DynamicBaseQuery";

export const companyBlackoutPeriodApi = createApi({
  reducerPath: "companyBlackoutPeriodApi",
  baseQuery: dynamicBaseQuery,
  tagTypes: ["BlackoutPeriods"],
  endpoints: (builder) => ({
    getAllBlackoutPeriods: builder.query<
      TGetBlackoutPeriodsListingResponse,
      TGetBlackoutPeriodsListingRequest
    >({
      query: () => ({
        url: "/company/settings/blackout-periods",
        method: "GET",
      }),
      providesTags: ["BlackoutPeriods"],
    }),
    addBlackoutPeriod: builder.mutation<
      TAddBlackoutPeriodResponse,
      IAddBlackoutPeriodRequest
    >({
      query: (data) => ({
        url: "/company/settings/blackout-periods",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["BlackoutPeriods"],
    }),
    getBlackoutPeriodById: builder.query<
      TGetBlackoutPeriodByIdResponse,
      TGetBlackoutPeriodByIdRequest
    >({
      query: ({ id }) => ({
        url: "/company/settings/blackout-periods" + `/${id}`,
        method: "GET",
      }),
      providesTags: ["BlackoutPeriods"],
    }),
    updateBlackoutPeriod: builder.mutation<
      TUpdateBlackoutPeriodResponse,
      IUpdateBlackoutPeriodRequest
    >({
      query: (data) => ({
        url: "/company/settings/blackout-periods/" + data.id,
        method: "PATCH",
        body: data.data,
      }),
      invalidatesTags: ["BlackoutPeriods"],
    }),
    deleteBlackoutPeriod: builder.mutation<
      { success: boolean; message: string },
      number
    >({
      query: (id) => ({
        url: "/company/settings/blackout-periods/" + id,
        method: "DELETE",
      }),
      invalidatesTags: ["BlackoutPeriods"],
    }),
  }),
});

export const {
  useGetAllBlackoutPeriodsQuery,
  useAddBlackoutPeriodMutation,
  useGetBlackoutPeriodByIdQuery,
  useUpdateBlackoutPeriodMutation,
  useDeleteBlackoutPeriodMutation,
} = companyBlackoutPeriodApi;
